// Services
import ApiService from "./api"

// Initialise new instance of the API service
const apiService = new ApiService()

export default class RegistrationService {
	// Which kinds of registration are open: { non_nhs_enabled, organisations_enabled }
	// Never throws: a network failure or a non-JSON response (e.g. an error page) returns an unsuccessful response, so
	// the form is shown and the API's own refusal decides instead
	async getSettings() {
		try {
			return await apiService.get("registration/settings")
		} catch (error) {
			return {
				success: false,
				message: "Could not check which registrations are open",
			}
		}
	}
}
